module.exports = __webpack_public_path__ + "static/img/2-2.2f7c875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/2-2.png
// module id = zbhY
// module chunks = 1